import PaymentSelect from './PaymentSelect'

export default PaymentSelect
